export enum LoadingState {
  INITIAL = "initial",
  LOADING = "loading",
  LOADED = "loaded",
  FAILED = "failed",
}
